import { camelToSnakeCase } from "../../utils/utils";

/**
 * Maps frontend sort field names to backend database column names
 * for Insurance Verification table sorting
 */
export const INSURANCE_VERIFICATION_SORT_FIELD_MAP: Record<string, string> = {
  postedDate: "posted_date_time",
  firstRetrieved: "created_at",
};

/**
 * Maps frontend filter field names to backend database column names
 * for Insurance Verification table filtering
 */
export const INSURANCE_VERIFICATION_FILTER_FIELD_MAP: Record<string, string> = {
  posted_datetime: "posted_date_time",
  first_retrieved: "created_at",
};

/**
 * Maps a frontend sort field name to its backend equivalent
 * @param frontendField - The field name from the frontend (camelCase)
 * @returns The corresponding backend field name (snake_case)
 */
export function mapInsuranceVerificationSortField(
  frontendField: string,
): string {
  if (frontendField in INSURANCE_VERIFICATION_SORT_FIELD_MAP) {
    return INSURANCE_VERIFICATION_SORT_FIELD_MAP[frontendField];
  }
  return camelToSnakeCase(frontendField);
}

/**
 * Maps a frontend filter field name to its backend equivalent
 * @param frontendField - The field name from the frontend
 * @returns The corresponding backend field name (snake_case)
 */
export function mapInsuranceVerificationFilterField(
  frontendField: string,
): string {
  const snakeCase = camelToSnakeCase(frontendField);
  if (snakeCase in INSURANCE_VERIFICATION_FILTER_FIELD_MAP) {
    return INSURANCE_VERIFICATION_FILTER_FIELD_MAP[snakeCase];
  }
  return snakeCase;
}
